// File: IncreaseAuthorizedCapital.jsx
import React from "react";

export default function IncreaseAuthorizedCapital() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Increase Authorized Capital / Issue of Shares / Transfer of Shares
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages capital restructuring compliances.
          </p>
          <p className="text-gray-700">
            Complete capital enhancement including Form SH-7 filing, EGM ordinary resolution, MOA alteration, stamp duty payment, share issuance via Form PAS-3, and share transfer Form SH-4 processing.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Capital restructuring - financial charts/shares) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/394372/pexels-photo-394372.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Authorized capital increase and share issuance compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless MCA capital restructuring filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Altered Memorandum of Association (MOA)</li>
                <li>Board and EGM resolutions</li>
                <li>Shareholder details and KYC</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Corporate structuring expertise with proven success in MCA capital enhancement filings.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Authorized Capital Enhancement
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Form SH-7 filing within 30 days of EGM ordinary resolution, MOA capital clause alteration, stamp duty payment, MCA V3 portal submission, and authorized capital limit updation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Share Issuance & Allotment
                </h3>
                <p className="text-gray-700 text-sm">
                  Form PAS-3 return filing within 30 days of allotment, board resolution approval, valuation report coordination, shareholder subscription agreements, share certificate issuance, and statutory register updates.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Share Transfer Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service share transfers via Form SH-4, stamp duty payment, board approval, DEMAT/Physical transfer processing, Form SH-4 execution verification, statutory register maintenance, and compliance certification.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
